var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4C7.58223 4 4 7.582 4 12C4 16.418 7.58223 20 12 20C16.4184 20 20 16.418 20 12C20 7.582 16.4184 4 12 4ZM14.9421 15.1393L14.7087 15.3727C14.5146 15.5667 14.1872 15.576 13.9832 15.392L10.9691 12.7553C10.7637 12.572 10.6083 12.1967 10.6217 11.922L10.9011 7.166C10.9157 6.89067 11.1525 6.66667 11.4279 6.66667H11.7566C12.032 6.66667 12.2681 6.89067 12.2814 7.16533L12.5101 11.1213C12.5241 11.3967 12.6848 11.788 12.8669 11.994L14.9634 14.4127C15.1455 14.6187 15.1368 14.9453 14.9421 15.1393Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/pending.25b2d2e59c63c920b36ac1cc3cc55a07.svg";
export { ForwardRef as ReactComponent };